import { API_BASE } from '@formosa/shared/constants/endpoints';

export const TRAVEL_API = `${API_BASE}/travel/api/v1`;
export const travelEndpoints = Object.freeze({
  groupTripParties: (id) => `${TRAVEL_API}/group-trips/${id}/parties`,
  partyAdditions: (id, partyId) => `${TRAVEL_API}/group-trips/${id}/parties/${partyId}/traveler-additions`,
  partyAdditionAction: (id, partyId, requestId, action) => `${TRAVEL_API}/group-trips/${id}/parties/${partyId}/traveler-additions/${requestId}/${action}`,

  explorePosts: `${TRAVEL_API}/social/discovery/posts`,
  socialMapLocations: `${TRAVEL_API}/social/map/locations`,
  followingTimeline: `${TRAVEL_API}/social/timeline/following`,
  socialPosts: `${TRAVEL_API}/social/posts`,
  socialPost: (postId) => `${TRAVEL_API}/social/posts/${postId}`,
  socialPostVisibility: (postId) => `${TRAVEL_API}/social/posts/${postId}/visibility`,
  socialPostUnpublish: (postId) => `${TRAVEL_API}/social/posts/${postId}/unpublish`,
  socialPostPublish: (postId) => `${TRAVEL_API}/social/posts/${postId}/publish`,
  socialPostDelete: (postId) => `${TRAVEL_API}/social/posts/${postId}/delete`,
  likeSocialPost: (postId) => `${TRAVEL_API}/social/posts/${postId}/like`,
  unlikeSocialPost: (postId) => `${TRAVEL_API}/social/posts/${postId}/unlike`,
  saveSocialPost: (postId) => `${TRAVEL_API}/social/posts/${postId}/save`,
  unsaveSocialPost: (postId) => `${TRAVEL_API}/social/posts/${postId}/unsave`,
  shareSocialPost: (postId) => `${TRAVEL_API}/social/posts/${postId}/share`,
  socialPostComments: (postId) => `${TRAVEL_API}/social/posts/${postId}/comments`,
  socialPostComment: (postId, commentId) => `${TRAVEL_API}/social/posts/${postId}/comments/${commentId}`,
  socialPostCommentDelete: (postId, commentId) => `${TRAVEL_API}/social/posts/${postId}/comments/${commentId}/delete`,
  socialPostReplies: (postId, commentId) => `${TRAVEL_API}/social/posts/${postId}/comments/${commentId}/replies`,
  followMember: (memberId) => `${TRAVEL_API}/social/members/${memberId}/follow`,
  unfollowMember: (memberId) => `${TRAVEL_API}/social/members/${memberId}/unfollow`,
  memberFollowers: (memberId) => `${TRAVEL_API}/social/members/${memberId}/followers`,
  memberFollowing: (memberId) => `${TRAVEL_API}/social/members/${memberId}/following`,
  socialReports: `${TRAVEL_API}/social/reports`,
  socialBlock: (memberId) => `${TRAVEL_API}/social/blocks/${memberId}`,
  socialBlocks: `${TRAVEL_API}/social/blocks`,
  creator: (memberId) => `${TRAVEL_API}/social/creators/${memberId}`,
  creatorPosts: (memberId) => `${TRAVEL_API}/social/creators/${memberId}/posts`,
  creatorJourneys: (memberId) => `${TRAVEL_API}/social/creators/${memberId}/journeys`,
  publicJourney: (publicationId) => `${TRAVEL_API}/public/journeys/${publicationId}`,
  publicJourneyTimeline: (publicationId) => `${TRAVEL_API}/public/journeys/${publicationId}/timeline`,
  /** 授權故事圖片（binary）；publicationId／mediaId 保持 opaque string。 */
  publicJourneyStoryMedia: (publicationId, mediaId) =>
    `${TRAVEL_API}/public/journeys/${publicationId}/story/media/${mediaId}`,
  publicJourneyEngagement: (publicationId) => `${TRAVEL_API}/public/journeys/${publicationId}/engagement-status`,
  copyPublicJourney: (publicationId) => `${TRAVEL_API}/public/journeys/${publicationId}/copy`,
  likePublicJourney: (publicationId) => `${TRAVEL_API}/public/journeys/${publicationId}/like`,
  unlikePublicJourney: (publicationId) => `${TRAVEL_API}/public/journeys/${publicationId}/unlike`,
  savePublicJourney: (publicationId) => `${TRAVEL_API}/public/journeys/${publicationId}/save`,
  unsavePublicJourney: (publicationId) => `${TRAVEL_API}/public/journeys/${publicationId}/unsave`,
  sharePublicJourneyToIm: (publicationId) => `${TRAVEL_API}/public/journeys/${publicationId}/share-to-im`,
  resolvePublicJourneyPublications: `${TRAVEL_API}/public/journey-publications/resolve`,
  publicJourneyComments: (publicationId) => `${TRAVEL_API}/public/journeys/${publicationId}/comments`,
  publicJourneyComment: (publicationId, commentId) => `${TRAVEL_API}/public/journeys/${publicationId}/comments/${commentId}`,
  publicJourneyCommentDelete: (publicationId, commentId) => `${TRAVEL_API}/public/journeys/${publicationId}/comments/${commentId}/delete`,
  publicJourneyReplies: (publicationId, commentId) => `${TRAVEL_API}/public/journeys/${publicationId}/comments/${commentId}/replies`,
  mySavedJourneys: `${TRAVEL_API}/me/saved-journeys`,
  mySaved: `${TRAVEL_API}/me/saved`,
  journeys: `${TRAVEL_API}/journeys`,
  journey: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}`,
  journeyRoutingEstimate: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/routing/estimate`,
  customLocations: `${TRAVEL_API}/custom-locations`,
  customLocationsMine: `${TRAVEL_API}/custom-locations/mine`,
  customLocationSubmitPublic: (id) => `${TRAVEL_API}/custom-locations/${id}/submit-public`,
  customLocationsPublicSearch: `${TRAVEL_API}/custom-locations/public/search`,
  journeyBasicInformation: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/basic-information`,
  journeyReady: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/ready`,
  journeyStart: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/start`,
  journeyComplete: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/complete`,
  journeyCancel: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/cancel`,
  journeyArchive: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/archive`,
  journeyDays: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/days`,
  journeyDay: (journeyId, journeyDayId) => `${TRAVEL_API}/journeys/${journeyId}/days/${journeyDayId}`,
  journeyDayMove: (journeyId, journeyDayId) => `${TRAVEL_API}/journeys/${journeyId}/days/${journeyDayId}/move`,
  journeySchedule: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/schedule`,
  journeyActivities: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/activities`,
  journeyActivity: (journeyId, activityId) => `${TRAVEL_API}/journeys/${journeyId}/activities/${activityId}`,
  journeyActivityMove: (journeyId, activityId) => `${TRAVEL_API}/journeys/${journeyId}/activities/${activityId}/move`,
  journeyActivityConfirm: (journeyId, activityId) => `${TRAVEL_API}/journeys/${journeyId}/activities/${activityId}/confirm`,
  journeyActivityStart: (journeyId, activityId) => `${TRAVEL_API}/journeys/${journeyId}/activities/${activityId}/start`,
  journeyActivityComplete: (journeyId, activityId) => `${TRAVEL_API}/journeys/${journeyId}/activities/${activityId}/complete`,
  journeyActivityCancel: (journeyId, activityId) => `${TRAVEL_API}/journeys/${journeyId}/activities/${activityId}/cancel`,
  journeyActivityChatShare: (journeyId, activityId) => `${TRAVEL_API}/journeys/${journeyId}/activities/${activityId}/chat-share`,
  journeyAccommodations: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/accommodations`,
  journeyAccommodation: (journeyId, accommodationId) => `${TRAVEL_API}/journeys/${journeyId}/accommodations/${accommodationId}`,
  journeyTransports: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/transports`,
  journeyTransport: (journeyId, transportId) => `${TRAVEL_API}/journeys/${journeyId}/transports/${transportId}`,
  journeyChecklist: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/checklist`,
  journeyChecklistItems: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/checklist-items`,
  journeyChecklistItem: (journeyId, itemId) => `${TRAVEL_API}/journeys/${journeyId}/checklist-items/${itemId}`,
  journeyChecklistItemComplete: (journeyId, itemId) => `${TRAVEL_API}/journeys/${journeyId}/checklist-items/${itemId}/complete`,
  journeyChecklistItemReopen: (journeyId, itemId) => `${TRAVEL_API}/journeys/${journeyId}/checklist-items/${itemId}/reopen`,
  journeyChecklistItemAssignee: (journeyId, itemId) => `${TRAVEL_API}/journeys/${journeyId}/checklist-items/${itemId}/assignee`,
  journeyBudget: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/budget`,
  journeyBudgetSummary: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/budget/summary`,
  journeyExpenses: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/expenses`,
  journeyExpenseSummary: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/expenses/summary`,
  journeyExpense: (journeyId, expenseId) => `${TRAVEL_API}/journeys/${journeyId}/expenses/${expenseId}`,
  journeyExpenseVoid: (journeyId, expenseId) => `${TRAVEL_API}/journeys/${journeyId}/expenses/${expenseId}/void`,
  journeyExpenseChatShare: (journeyId, expenseId) => `${TRAVEL_API}/journeys/${journeyId}/expenses/${expenseId}/chat-share`,
  journeySplitCalculations: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/split-calculations`,
  journeySplitCalculation: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/split-calculation`,
  journeySplitMemberBalances: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/split-member-balances`,
  journeyBalanceChatShare: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/balance/chat-share`,
  journeyDecisions: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/decisions`,
  journeyDecision: (journeyId, decisionId) => `${TRAVEL_API}/journeys/${journeyId}/decisions/${decisionId}`,
  journeyDecisionOpen: (journeyId, decisionId) => `${TRAVEL_API}/journeys/${journeyId}/decisions/${decisionId}/open`,
  journeyDecisionVotes: (journeyId, decisionId) => `${TRAVEL_API}/journeys/${journeyId}/decisions/${decisionId}/votes`,
  journeyDecisionClose: (journeyId, decisionId) => `${TRAVEL_API}/journeys/${journeyId}/decisions/${decisionId}/close`,
  journeyDecisionCancel: (journeyId, decisionId) => `${TRAVEL_API}/journeys/${journeyId}/decisions/${decisionId}/cancel`,
  journeyDecisionResults: (journeyId, decisionId) => `${TRAVEL_API}/journeys/${journeyId}/decisions/${decisionId}/results`,
  journeyMemories: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/memories`,
  journeyMemoriesMine: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/memories/mine`,
  journeyMemory: (journeyId, memoryEntryId) => `${TRAVEL_API}/journeys/${journeyId}/memories/${memoryEntryId}`,
  journeyMemoryVisibility: (journeyId, memoryEntryId) => `${TRAVEL_API}/journeys/${journeyId}/memories/${memoryEntryId}/visibility`,
  journeyMemoryHide: (journeyId, memoryEntryId) => `${TRAVEL_API}/journeys/${journeyId}/memories/${memoryEntryId}/hide`,
  journeyMemoryRestore: (journeyId, memoryEntryId) => `${TRAVEL_API}/journeys/${journeyId}/memories/${memoryEntryId}/restore`,
  journeyMemoryDelete: (journeyId, memoryEntryId) => `${TRAVEL_API}/journeys/${journeyId}/memories/${memoryEntryId}/delete`,
  journeyMemoryChatShare: (journeyId, memoryEntryId) => `${TRAVEL_API}/journeys/${journeyId}/memories/${memoryEntryId}/chat-share`,
  journeyMemorySocialPublications: (journeyId, memoryEntryId) => (
    `${TRAVEL_API}/journeys/${journeyId}/memories/${memoryEntryId}/social-publications`
  ),
  journeyPublication: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/publication`,
  journeyPublicationVisibility: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/publication/visibility`,
  journeyPublicationCopyPermission: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/publication/copy-permission`,
  journeyPublicationPromotionPermission: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/publication/promotion-permission`,
  journeyPublicationPublish: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/publication/publish`,
  journeyPublicationUnpublish: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/publication/unpublish`,
  journeyPublicationRefresh: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/publication/refresh`,
  journeyPublicationStoryItems: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/publication/story-items`,
  journeyPublicationStoryItemSelection: (journeyId, memoryEntryId) => (
    `${TRAVEL_API}/journeys/${journeyId}/publication/story-items/${memoryEntryId}/selection`
  ),
  journeyPublicationStoryOrder: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/publication/story-items/order`,
  mePublicationConsents: () => `${TRAVEL_API}/me/publication-consents`,
  journeyMemoryPublicationConsent: (journeyId, memoryEntryId) => (
    `${TRAVEL_API}/journeys/${journeyId}/memories/${memoryEntryId}/publication-consent`
  ),
  journeyConversation: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/conversation`,
  journeyCollaborationTimeline: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/collaboration-timeline`,
  journeyNotices: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/notices`,
  journeyNoticeUnreadCount: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/notices/unread-count`,
  journeyNoticeRead: (journeyId, noticeId) => `${TRAVEL_API}/journeys/${journeyId}/notices/${noticeId}/read`,
  journeyNoticeAcknowledge: (journeyId, noticeId) => (
    `${TRAVEL_API}/journeys/${journeyId}/notices/${noticeId}/acknowledge`
  ),
  journeySituations: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/situations`,
  journeySituation: (journeyId, situationId) => `${TRAVEL_API}/journeys/${journeyId}/situations/${situationId}`,
  journeySituationAssign: (journeyId, situationId) => (
    `${TRAVEL_API}/journeys/${journeyId}/situations/${situationId}/assign`
  ),
  journeySituationResolve: (journeyId, situationId) => (
    `${TRAVEL_API}/journeys/${journeyId}/situations/${situationId}/resolve`
  ),
  journeySituationCancel: (journeyId, situationId) => (
    `${TRAVEL_API}/journeys/${journeyId}/situations/${situationId}/cancel`
  ),
  journeyInvitations: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/invitations`,
  journeyLeave: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/leave`,
  journeyMemberRemove: (journeyId, memberId) => (
    `${TRAVEL_API}/journeys/${journeyId}/members/${memberId}/remove`
  ),
  journeyOwnershipTransfer: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/ownership/transfer`,
  incomingJourneyInvitations: `${TRAVEL_API}/journey-invitations`,
  discoveryLocations: `${TRAVEL_API}/discovery/locations`,
  discoveryLocation: (locationId) => `${TRAVEL_API}/discovery/locations/${locationId}`,
  discoveryFeed: `${TRAVEL_API}/discovery/feed`,
  discoveryFeedImpressions: `${TRAVEL_API}/discovery/feed/impressions`,
  discoveryJourneys: `${TRAVEL_API}/discovery/journeys`,
  discoverySuggestions: `${TRAVEL_API}/discovery/suggestions`,
  discoveryNotInterested: `${TRAVEL_API}/discovery/preferences/not-interested`,
  discoveryNotInterestedUndo: `${TRAVEL_API}/discovery/preferences/not-interested/undo`,
  discoveryMuteCreator: (creatorMemberId) => `${TRAVEL_API}/discovery/preferences/creators/${creatorMemberId}/mute`,
  discoveryUnmuteCreator: (creatorMemberId) => `${TRAVEL_API}/discovery/preferences/creators/${creatorMemberId}/unmute`,
  discoveryResetPreferences: `${TRAVEL_API}/discovery/preferences/reset`,
  discoveryPreferencesHide: `${TRAVEL_API}/discovery/preferences/hide`,
  discoveryFeedBehavior: `${TRAVEL_API}/discovery/feed/behavior`,
  incomingJourneyInvitation: (invitationId) => `${TRAVEL_API}/journey-invitations/${invitationId}`,
  journeyInvitationAccept: (invitationId) => `${TRAVEL_API}/journey-invitations/${invitationId}/accept`,
  journeyInvitationDecline: (invitationId) => `${TRAVEL_API}/journey-invitations/${invitationId}/decline`,
  journeyInvitationRevoke: (invitationId) => `${TRAVEL_API}/journey-invitations/${invitationId}/revoke`,
  groupTrips: `${TRAVEL_API}/group-trips`,
  groupTrip: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}`,
  groupTripBookings: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/bookings`,
  groupTripDisruptionCases: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/disruption-cases`,
  groupTripDisruptionCase: (groupTripId, caseId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/disruption-cases/${caseId}`
  ),
  groupTripDisruptionAssessment: (groupTripId, caseId, componentId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/disruption-cases/${caseId}/components/${componentId}/assessments`
  ),
  groupTripDisruptionConfirmationRequest: (groupTripId, caseId, componentId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/disruption-cases/${caseId}/components/${componentId}/supplier-confirmation-requests`
  ),
  groupTripDisruptionConfirmation: (groupTripId, caseId, componentId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/disruption-cases/${caseId}/components/${componentId}/supplier-confirmations`
  ),
  groupTripDisruptionClose: (groupTripId, caseId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/disruption-cases/${caseId}/close`
  ),
  groupTripSettlementProposals: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/settlement-proposals`,
  groupTripSettlementProposal: (groupTripId, proposalId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/settlement-proposals/${proposalId}`
  ),
  groupTripSettlementProposalAction: (groupTripId, proposalId, action) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/settlement-proposals/${proposalId}/${action}`
  ),
  groupTripOpen: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/open`,
  groupTripClose: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/close`,
  groupTripCancel: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/cancel`,
  groupTripApplications: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/applications`,
  groupTripApplicationWithdraw: (groupTripId, applicationId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/applications/${applicationId}/withdraw`
  ),
  groupTripApplicationApprove: (groupTripId, applicationId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/applications/${applicationId}/approve`
  ),
  groupTripApplicationReject: (groupTripId, applicationId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/applications/${applicationId}/reject`
  ),
  groupTripParticipants: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/participants`,
  groupTripTravelers: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/travelers`,
  groupTripJourneyActivities: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/journey-activities`,
  groupTripRuntimeTimeline: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/runtime-timeline`,
  groupTripLateJoinRequests: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/late-join-requests`,
  groupTripLateJoinMine: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/late-join-requests/me`,
  groupTripLateJoinCancel: (groupTripId, requestId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/late-join-requests/${requestId}/cancel`
  ),
  groupTripLateJoinReject: (groupTripId, requestId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/late-join-requests/${requestId}/reject`
  ),
  groupTripLateJoinApprove: (groupTripId, requestId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/late-join-requests/${requestId}/approve`
  ),
  groupTripRuntimeDecisions: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/runtime-decisions`,
  groupTripRuntimeDecisionVotes: (groupTripId, decisionId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/runtime-decisions/${decisionId}/votes`
  ),
  groupTripRuntimeDecisionClose: (groupTripId, decisionId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/runtime-decisions/${decisionId}/close`
  ),
  groupTripRuntimeDecisionConfirm: (groupTripId, decisionId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/runtime-decisions/${decisionId}/confirm`
  ),
  groupTripActivityParticipation: (groupTripId, journeyActivityId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/journey-activities/${journeyActivityId}/participation`
  ),
  groupTripDisruption: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/disruption`,
  groupTripIndependentPeriod: (groupTripId, travelerId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/travelers/${travelerId}/independent-periods`
  ),
  groupTripIndependentPeriodEnd: (groupTripId, travelerId, periodId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/travelers/${travelerId}/independent-periods/${periodId}/end`
  ),
  groupTripParticipationEnd: (groupTripId, travelerId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/travelers/${travelerId}/participation-end`
  ),
  groupTripTravelerParticipation: (groupTripId, journeyActivityId, travelerId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/journey-activities/${journeyActivityId}/travelers/${travelerId}/participation`
  ),
  groupTripTravelerClaim: (groupTripId, travelerId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/travelers/${travelerId}/claim-invitations`
  ),
  groupTripTravelerClaimAccept: `${TRAVEL_API}/group-trips/traveler-claims/accept`,
  groupTripActual: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/actual`,
  groupTripTravelerActual: (groupTripId, travelerId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/travelers/${travelerId}/actual`
  ),
  groupTripPersonalContinuations: (groupTripId, travelerId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/travelers/${travelerId}/personal-continuations`
  ),
  journeyContinuationSource: (journeyId) => `${TRAVEL_API}/journeys/${journeyId}/continuation-source`,
  groupTripParticipantMe: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/participants/me`,
  groupTripParticipantWithdraw: (groupTripId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/participants/me/withdraw`
  ),
  groupTripParticipantRemove: (groupTripId, participantId) => (
    `${TRAVEL_API}/group-trips/${groupTripId}/participants/${participantId}/remove`
  ),
  groupTripConversation: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/conversation`,
  myGroupTrips: `${TRAVEL_API}/me/group-trips`,
  myVipEntitlements: `${TRAVEL_API}/me/vip-entitlements`,
  publicGroupTrips: `${TRAVEL_API}/public/group-trips`,
  publicGroupTrip: (groupTripId) => `${TRAVEL_API}/public/group-trips/${groupTripId}`,
  groupTripReviews: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/reviews`,
  groupTripReview: (groupTripId, reviewId) => `${TRAVEL_API}/group-trips/${groupTripId}/reviews/${reviewId}`,
  groupTripReviewEligibility: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/reviews/eligibility`,
  groupTripReviewMe: (groupTripId) => `${TRAVEL_API}/group-trips/${groupTripId}/reviews/me`,
  memberTravelReputation: (memberId) => `${TRAVEL_API}/members/${memberId}/travel-reputation`,
  meGroupTripNotices: `${TRAVEL_API}/me/group-trip-notices`,
  meGroupTripNoticesUnreadCount: `${TRAVEL_API}/me/group-trip-notices/unread-count`,
  meGroupTripNoticeRead: (noticeId) => `${TRAVEL_API}/me/group-trip-notices/${noticeId}/read`,
  meGroupTripNoticesReadAll: `${TRAVEL_API}/me/group-trip-notices/read-all`,
  meNotifications: `${TRAVEL_API}/me/notifications`,
  meNotificationsUnreadCount: `${TRAVEL_API}/me/notifications/unread-count`,
  meNotificationRead: (notificationId) => `${TRAVEL_API}/me/notifications/${notificationId}/read`,
  meNotificationsReadAll: `${TRAVEL_API}/me/notifications/read-all`,
  meNotificationCenterUnreadCount: `${TRAVEL_API}/me/notification-center/unread-count`,
  myPersonalMap: `${TRAVEL_API}/me/personal-map`,
  myPersonalMapHidden: (locationId) => `${TRAVEL_API}/me/personal-map/${locationId}/hidden`,
  resolveExternalLocation: `${TRAVEL_API}/map/external-locations/resolve`,
  myTrades: `${TRAVEL_API}/me/trades`,
  commerceHistory: `${TRAVEL_API}/me/commerce-history`,
  trades: `${TRAVEL_API}/trades`,
  trade: (tradeId) => `${TRAVEL_API}/trades/${tradeId}`,
  tradeCancel: (tradeId) => `${TRAVEL_API}/trades/${tradeId}/cancel`,
  tradePayment: (tradeId) => `${TRAVEL_API}/trades/${tradeId}/payment`,
});
